import { Box, Stack } from '@mui/material';

import { FInput, FSelect } from '../../../../../../components/baseV2';
import { DISCHARGE_REASON_OTHER } from '../constants';
import { DISCHARGE_EXPLAIN_OTHER_SX } from '../styles';

import type { DischargeReasonDraftFieldsProps } from './types';

export default function DischargeReasonDraftFields({
  draft,
  options,
  disabled,
  onReasonChange,
  onExplanationChange,
  explanationError,
}: DischargeReasonDraftFieldsProps) {
  return (
    <Stack spacing={0}>
      <FSelect
        disabled={disabled}
        fullWidth
        inputHeight={40}
        label="Reasons to decrease hours or discharge may include"
        onUpdate={onReasonChange}
        options={options}
        placeholder="Select reasons"
        required
        value={draft.reason}
      />
      {draft.reason === DISCHARGE_REASON_OTHER ? (
        <Box sx={DISCHARGE_EXPLAIN_OTHER_SX}>
          <FInput
            disabled={disabled}
            error={Boolean(explanationError)}
            fullWidth
            helperText={explanationError}
            label="Explain other"
            onChange={(event) => onExplanationChange(event.target.value)}
            placeholder="Enter other detail"
            required
            value={draft.explanation}
          />
        </Box>
      ) : null}
    </Stack>
  );
}
